import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '@services/support/loader.service';
import { SnackbarService } from '@services/support/snackbar.service';
import { WorkflowService } from '@services/workflow.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-video-upload-modal',
    templateUrl: './video-upload-modal-2.component.html',
    styleUrls: ['./video-upload-modal-2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VideoUploadModalComponent implements OnInit {

  private readonly durationLimit = 1860

  createWorkflow : EventEmitter<any> = new EventEmitter

  isUpload
  isLoading
  subscriptions: Subscription[] = []

  uploadedFile
  fileName
  videoDuration: number | null = null;
  showTimeLimitError

  uploadProgress

  isFileUploading = false

  constructor(
    private workflowService: WorkflowService,
    public loaderService: LoaderService,
    public modalRef: BsModalRef,
    private translateService: TranslateService,
    private snackBarService: SnackbarService
  ) { }

  ngOnInit(): void {
  }

  chooseButtonUpload( event: any): void {
    const input = event.target as HTMLInputElement;
    this.handleSelectedFiles(input.files)
  }

  showVideoTimeLimitError() {
    this.showTimeLimitError = true
  }

  dragDropUpload(event) {
    if (!environment.electron) {
      this.handleSelectedFiles(event)
    }
  }

  private handleSelectedFiles(selectedFiles: FileList | null): void {
    if (!selectedFiles?.length) {
      return
    }

    this.isUpload = true
    this.showTimeLimitError = false

    const file = selectedFiles[0]
    const video = document.createElement('video')

    video.preload = 'metadata'
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src)
      this.videoDuration = video.duration

      if (this.videoDuration <= this.durationLimit) {
        this.previewUpload(selectedFiles)
        return
      }

      this.isUpload = false
      this.showVideoTimeLimitError()
    }
    video.src = URL.createObjectURL(file)
  }

  private previewUpload(selectedFile: FileList): void {
    if (selectedFile?.length) {
      this.isFileUploading = true
      this.isLoading = true;
      this.loaderService.show()
      this.subscriptions.push(this.uploadfile(selectedFile).subscribe({
        next: (resp) => {
          if(resp){
            this.uploadedFile = {url : resp['data'].files[0].url, key : resp['data'].files[0].key}
            this.isUpload = false
            this.fileName = selectedFile[0].name
            this.isLoading = false;
            this.isFileUploading = false
            this.loaderService.hide()
          }
        },
        error: (e) => {
          this.snackBarService.error(this.translateService.instant('ERRORS.UPLOAD-ERROR'))
          this.isUpload = false
          this.isLoading = false
          this.isFileUploading = false
          this.loaderService.hide()
        }
      }))
    }
  }

  uploadfile(file) {
    /*
    let formData = new FormData();
    
      if(file.length){
        for (let i = 0; i < file.length; i++) {
          formData.append(file[i].name, file[i])
        }
      }else{
        formData.append(file.name, file)
      }

      return this.workflowService.uploadVideoForWorkflowProgress(formData, (progress: number) => {
        this.uploadProgress = progress;
      });
      
      // return this.workflowService.uploadVideoForWorkflow(formData)
    */

    return this.workflowService.uploadVideoForWorkflowProgress2(file[0], (progress: number) => {
      this.uploadProgress = progress;
    });

  }

  close(): void {
    this.modalRef.hide();
  }

  createWorkflowWithVideoFile() {
    this.createWorkflow.emit({...this.uploadedFile, fileName: this.fileName})
    this.modalRef.hide();
  }

}
